module.exports = __webpack_public_path__ + "img/work2018TED.21721b9b.png";